import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  loading: true,
  error: null,
  uid: null,
  range: 'week',
  calls: [],
};

export const analyticUserDataSlice = createSlice({
  name: 'analyticUserData',
  initialState,
  reducers: {
    setUserAnalyticData: (state, action) => {
      const { uid, range, calls = [] } = action.payload || {};
      state.loading = false;
      state.error = null;
      if (uid != null) state.uid = uid;
      if (range) state.range = range;
      state.calls = calls;
    },
    resetUserAnalyticData: () => initialState,
  },
});

export const { setUserAnalyticData, resetUserAnalyticData } = analyticUserDataSlice.actions;
//Selectors
export const selectUserAnalyticData = (state) => state.analyticUserData;
export default analyticUserDataSlice.reducer;
